import React from 'react';
import PropTypes from 'prop-types';
import {Table, Button, Checkbox} from 'semantic-ui-react';
import moment from 'moment';

const UserAccountsSearchResult = ({user, onView, onLogin}) => {
    return (
        <Table.Row>
            <Table.Cell>
                <Button icon="eye" onClick={onView} data={user} />
                <Button icon="id badge" primary onClick={onLogin} data={user} />
            </Table.Cell>
            <Table.Cell>
                {user.name}
            </Table.Cell>
            <Table.Cell>
                {user.userName}
            </Table.Cell>
            <Table.Cell>
                {user.email}
            </Table.Cell>
            <Table.Cell>
                {user.policies.map((policy, index) => <span key={index} title={`Added On: ${moment.utc(policy.addedOn).tz('US/Eastern').format('LLLL')}`}>{policy.policyNumber + " "}</span>)}
            </Table.Cell>
            <Table.Cell>
                {user.deliveryEnabled && moment.utc(user.deliveryEnabled).tz('US/Eastern').format('L LT')}
            </Table.Cell>
            <Table.Cell>
                <Checkbox checked={user.isAdmin} disabled />
            </Table.Cell>
        </Table.Row>
    );
};

UserAccountsSearchResult.propTypes = {
    user: PropTypes.object.isRequired,
    onLogin: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired,
};

export default UserAccountsSearchResult;